module.exports = "<div [hidden]=\"!isShowingRouteLoadIndicator\" class=\"progressbar_myT\"></div>\n\n<router-outlet></router-outlet>\n"